import React, { type FC } from 'react';
import { useTranslation } from '@/app/components/translations/Translation';
import { usePageWrapperData } from '@/app/common/pageWrapperProvider.tsx';
import { type PROMOTION_TYPES } from '@/domainLogic/index.ts';
import { IconOrLegacyAsset } from '@/app/common/icons/IconOrLegacyAsset';
import type { StarfishIconRef } from '@/app/common/icons/starfish';
import { MarkerPromotionStyled } from './styled';

type PromotionProps = {
  icon: StarfishIconRef | string | undefined;
  isWaiting: boolean;
  promotionType: PROMOTION_TYPES | undefined;
};

const Promotion: FC<PromotionProps> = ({ icon, isWaiting, promotionType }) => {
  const { t } = useTranslation();
  const { localization } = usePageWrapperData();
  const imageBasePath = localization?.imageBasePath;
  const lastMinuteDeals = localization?.configValuesApp?.lastMinuteDeals;
  const altText = t(lastMinuteDeals ? 'vacation.oss.cards.lastminute_deals' : 'vacation.oss.cards.flash_sales_label');

  return icon && !isWaiting ? (
    <MarkerPromotionStyled promotionType={promotionType} lastMinuteDeals={lastMinuteDeals}>
      <IconOrLegacyAsset
        icon={typeof icon === 'string' ? `${imageBasePath}icons/${icon}` : icon}
        size={14}
        alt={altText}
      />
    </MarkerPromotionStyled>
  ) : null;
};

export default Promotion;
